export default __webpack_public_path__ + "static/media/analyze-icon.fdbaa446.svg";